import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Button from "components/CustomButtons/Button.js";
import FileUpload from "components/FileUpload/FileUploadSanction";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import brandTheme from "brandTheme/Theme";
import { FormControlLabel, Grid, Switch } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import axios from "axios";
import ToastModal from "views/components/ToastModal";
import ConfirmationModal from "views/components/ConfirmationModal";
import OtpModal from "../OtpModal/OtpModal";
import { parseAndSetFlag } from "utils/Utils";
import { removeSpecialCharFileName } from "utils/Utils";
import { headerLabel } from "assets/properties/properties";
import { loanApplicationStatusNamesList } from "assets/properties/properties";
import { checkForRepledgeAccount } from "utils/Utils";
import { APPLICATION_TYPE_RE_PLEDGE } from "assets/properties/properties";

const InsuranceLetter = ({
  setNext,
  setBack,
  loanApplicationId,
  classes,
  prePledgeLoan,
  closeModal,
  editable,
  setIsEsign,
  isEsign,
  esingDisable,
  setEsignDisable,
  featureFlags,
  loanType,
}) => {
  let fileUploadComponent = useRef();
  const [preview, setPreView] = useState("");
  const [imagefile, setImagefile] = useState("");
  const [screenshotCheque, setScreenshotCheque] = useState(null);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [backFlex, setBackFlex] = useState(false);
  const [senctionPreview, setSanctionPreview]= useState('')
  const [callInProgress, setCallInProgress] = useState(false);
  const [disableGenerate, setDisableGenerate]= useState(false);
  const [htmlData,setHtmlData]=useState("");
  const [showLinkedLoanBranchFlag, setEsignPartB] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const outletData = featureFlags;
  const enableInsuranceEsignFlag = parseAndSetFlag(outletData?.enableInsuranceEsignFlag);
  const [confirmationModal1, setConfirmationModal1] = useState(false);
  const [confirmationModalHeader1, setConfirmationModalHeader1] = useState("");
  const [confirmationModalMsg1, setConfirmationModalMsg1] = useState("");
  const [generateLetter, setGenerateLetter]=useState(false)
  const sanctionletterLoaderMessage = outletData?.sanctionLetterLoaderMessage;
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const navigate = useNavigate();

  useEffect(() => {
    GetSanctionLetterDetails();
  }, []);
  useEffect(()=>{
      if (preview && isEsign) {
        checkForEsign();
      }
    },[preview])
    useEffect(()=>{
      if(screenshotCheque !== null){
        const localUrl = URL.createObjectURL(screenshotCheque);
        setPreView(localUrl); 
      }
    },[screenshotCheque])

  const checkForEsign = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.GET_ESIGN_INSURANCE_LETTER + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.fileLink && res?.data?.fileLink?.includes('esigned')) {
      setSanctionPreview(res?.data?.fileLink);
      setEsignDisable(true);
      setIsEsign(true);
    } else if(res?.data?.fileLink){
      setSanctionPreview(res?.data?.fileLink);
      setEsignDisable(false);
      setIsEsign(false);
    }else {
      GetSanctionLetterDetails();
  }
  }
  const GetSanctionLetterDetails = async () => {
    setCallInProgress(true)
    const loanAccountNumber = loanApplicationId
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanAccountNumber,
      method: "GET",
      authToken: authToken,
    })
    setCallInProgress(false);
    if (res?.data?.insuranceLetterLink) {
      if (
        res?.data?.insuranceLetterLink?.includes("esigned")
      ) {
        setEsignDisable(true);
        setIsEsign(true);
        setSanctionPreview(res?.data?.insuranceLetterLink);
      } else {
        setEsignDisable(false);
        setIsEsign(false);
        setSanctionPreview(res?.data?.insuranceLetterLink);
        if (!editable) {
          setPreView(res?.data?.insuranceLetterLink);
        }
      }
    }
  };
  const decode = (str) => {
    let parsedStr = str.replace(/[{}]/g, '');

    // escape unescaped double quotes to prevent error with
    // added double quotes in json string
    parsedStr = parsedStr.replace(/(^|[^\\])((\\\\)*")/g, "$1\\$2");

    try {
      parsedStr = JSON.parse(`"${parsedStr}"`);
    } catch (e) {
      return str;
    }
    return parsedStr;
  };
  const GenerateSanctionLetter = async () => {
    setGenerateLetter(true)
    setCallInProgress(true)
    //SANCTION_LETTER
    const res = await apiHandler({
      url: endpoint.GENERATE_INSURANCE_LETTER + loanApplicationId,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false)
    setGenerateLetter(true)
    if (res?.data?.fileLink) {
        setPreView(res?.data?.fileLink)
    }
  };
    const handlecanceluser = () => {
        setBack();
        //props.history.go(-1);
      };
      const proceedApplication = () => {
        setConfirmationModalHeader("Disbursal");
        setConfirmationModalMsg(
          "Are you sure you want to Proceed this Loan to LMS"
        );
        setConfirmationModal(true);
        setLoanAPPLICATIONID(loanApplicationId);
      };
      const handleNegativeResponse = () => {
        setConfirmationModal(false);
        setConfirmationModalHeader("");
        setConfirmationModalMsg("");
        setLoanAPPLICATIONID("");
      };
      const handlePositiveResponse = async () => {
        let id = loanAPPLICATIONID;
        handleNegativeResponse();
        // Call API to delete loanMarking
        onClickProceedData(id);
      };
      const onClickProceedData = async (id) => {
        setCallInProgress(true);
        if (loanType === APPLICATION_TYPE_RE_PLEDGE) {
      const checkResult = await checkForRepledgeAccount(authToken, prePledgeLoan);
      if(checkResult?.data?.error_code){
        toastUpdate("Error",checkResult?.data?.user_description,true);
        return;
      }else{
        const filteredData = checkResult?.data?.filter(item => Number(item?.id) !== Number(id)) || [];
          if (Array.isArray(filteredData) && filteredData.length > 0) {
          const ids = filteredData
            .map(item => item?.id)
            .filter(Boolean);
          const idsText = ids.length > 0 ? ` Lead Ids: ${ids.join(", ")}` : "";
          toastUpdate(
            "Error",
            `Already Repledge Loan Present with ${idsText}`,
            true
          );
          return false;
        }
      }
  }
        const result = await apiHandler({
        url: endpoint.DISBURSAL_APPLICATION_LMS + id + `?newDisbursement=true`,
          method: "POST",
          authToken: authToken,
        });
        setCallInProgress(false);
        if (result?.data?.error_code) {
          toastUpdate("Error", result?.data?.user_description, true);
        } else {
        navigate("/loanservice/disbursLms", { state: { from: '' } });
        }
      };
      const handleSwitchChange = async () =>{
        setIsEsign(!isEsign);
      }
      const handleEsign=async()=>{
        setCallInProgress(true)
        //SANCTIONLETTER_UPDATE
        const res = await apiHandler({
          url: endpoint.GET_ESIGN_INSURANCE_LETTER + loanApplicationId,
          method: "POST",
          authToken: authToken,
        });
        setCallInProgress(false)
        if(res?.data?.error_code){
          toastUpdate("Error", res?.data?.user_description, true);
        }
        else {
          // openHtmlInNewTab(res?.data);
          if(res?.data?.status === "OTP_VALIDATION"){
            setTransactionId(res?.data?.transactionId)
            setShowModal(true);
          }else{
            openHtmlInNewTab(res?.data);
            setNext();
          }
        }
      }
        const openHtmlInNewTab = (htmlResponse) => {
          const blob = new Blob([htmlResponse], { type: 'text/html' });
          const url = URL.createObjectURL(blob);
          setHtmlData(url)
          window.open(url);
    
        };
        const handleEsignNext = () =>{
          if(!esingDisable){
            toastUpdate("Error","Please Esign the Document", true);
          } else{
            setNext()
          }
        }
          const handleUpload = async () => {
            if (imagefile) {
                UpdateSanctionLetterPartB(imagefile);
            } else {
              if (screenshotCheque || htmlData) {
                setCallInProgress(true);
                const formData = new FormData();
                const fileName = removeSpecialCharFileName(screenshotCheque.name);
                formData.append("file", screenshotCheque, fileName);
                const path = await apiHandler({
                  url: endpoint.FILE_UPLOAD,
                  method: "POST",
                  authToken: authToken,
                  data: formData,
                });
                setCallInProgress(false);
                const uploadedPath = path.data;
                UpdateSanctionLetterPartB(uploadedPath.name);
              } else {
                toastUpdate("Error","Upload Signed Insurance letter Before Submited", true);
              }
            }
            // setNext(); // kamal
          };
          const UpdateSanctionLetterPartB = async (filename) => {
            setCallInProgress(true)
            //SANCTIONLETTER_UPDATE
            const res = await apiHandler({
              url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
              method: "POST",
              authToken: authToken,
              data: {
                loanApplicationId: loanApplicationId,
                insuranceLetterLink: filename,
              },
            });
            setCallInProgress(false)
            //this.setState({ callInProgress: false });
            if (res?.data?.error_code && res?.data?.error_code === 403) {
              toastUpdate("Error", res?.data?.user_description, true);
              return;
            } else if (res?.data?.error_code) {
              toastUpdate("Error", res?.data?.user_description, true);
              return;
            } else {
              toastUpdate("Success", "Update Insurance Letter successfully", true);
              setBackFlex(true);
              setNext();
            }
        
            //  props.navigate(`/admin/document/` + params.loanApplicationId);
          }; 
          const handleClose = () => {
            setShowModal(!showModal);
          };   
            const sendEMailOtp = async () => {
              setCallInProgress(true);
              const res = await apiHandler({
                url: endpoint.RESEND_OTP_ESIGN + transactionId,
                method: "PUT",
                authToken: authToken,
              });
              setCallInProgress(false);
              if (res?.data?.error_code) {
                toastUpdate("Error", res?.data?.user_description, true);
              }else{
                toastUpdate("Success", "Otp sent successfully", true);
              }
            };
          const Otp = async (code1) => {
            setCallInProgress(true);
            const response = await apiHandler({
              url: endpoint.OTP_VALIDATE_ESIGN,
              method: "POST",
              authToken: authToken,
              data: {
                txnId: transactionId,
                otp: code1,
              },
            });
            setCallInProgress(false);
              if (response?.data?.error_code) {
                toastUpdate("Error",'Kindly verify the otp or resend the otp', true);
              } else {
                setNext();
                setShowModal(false);
              }
            };
            const handleProceedUpload=()=>{
        setConfirmationModalHeader1("Preview");
    setConfirmationModalMsg1("Preview uploaded insurance letter");
    setConfirmationModal1(true);
  }
      const handleNegativeUploadResponse = () => {
    setConfirmationModal1(false);
    setConfirmationModalHeader1("");
    setConfirmationModalMsg1("");
  };
  const handlePositiveUploadResponse = async () => {
    handleNegativeUploadResponse();
    // Call API to delete loanMarking
    handleUpload();
  };
  return (
    // <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
             <SubHeader
                       label={headerLabel?.insuranceLetter}
                        subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                        onlyLabel/>
        </Grid>
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer>
    {!preview ? 
    <>
     <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "center" }}
            >
              <Button onClick={() => GenerateSanctionLetter()} className={classes.nextButton} disabled={disableGenerate}>Generate</Button>
              {senctionPreview && <Button className={classes.nextButton1} onClick={()=> setPreView(senctionPreview)}>Preview</Button>}
       </GridItem>
     </>
 : 
 <>
 <GridItem
                  xs={12}
                  sm={12}
                  md={8}
                  lg={8}
                  style={{ textAlign: "start" }}
                >
 {enableInsuranceEsignFlag &&
  <>
                  <label
                    style={{
                      text: "bold",
                      marginRight: "10px",
                      color: "black",
                    }}
                  >
                    Do you want to Esign with Aadhar{" "}
                  </label>
                  <label style={{ marginRight: "15px", color: "black" }}>
                    No
                  </label>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isEsign}
                        onChange={handleSwitchChange}
                        name="checkedB"
                        color="primary"
                        disabled={esingDisable}
                      />
                    }
                  />
                  <label style={{ color: "black" }}>Yes</label>
                  </>
                }
                </GridItem>
                {!esingDisable &&
  <>
          {isEsign  ? 
           (<GridItem xs={12} sm={12} md={4} lg={4} style={{ textAlign: "end" }}>
           <Button
             size="small"
             className={classes.nextButton}
             onClick={handleEsign}
           >
             Esign
           </Button>
         </GridItem>
       ) : (
         <GridItem
         xs={12}
         sm={12}
         md={4}
         lg={4}
         style={{ textAlign: "end" }}
       >
           <FileUpload
             // avatar={imagefile ? imagefile : DefaultCheque}
             supportedMimeType={["application/pdf"]}
             addButtonProps={{
               color: brandTheme.buttonColor,
               round: false,
             }}
             changeButtonProps={{
               color: brandTheme.buttonColor,
               round: false,
             }}
             removeButtonProps={{
               color: "danger",
               round: false,
             }}
             sendFile={(file) => {
               setScreenshotCheque(file);
               setImagefile("");
             }}
             disabledButton={htmlData}
             ref={fileUploadComponent}
             classes={classes}
             insurance
           />
         </GridItem>)
            }
            </>
          }
            <GridItem xs={12} sm={12} md={12} lg={12}>
              {preview !== "" ? (
                <iframe src={preview?preview:senctionPreview} width="100%" height="500px" />
              ) : (
                <div>Downloading Insurance Document</div>
              )}
            </GridItem>
            </>
           }
          </GridContainer>
          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{textAlign: window.innerWidth < 360 ? "center" : "right", }}
            >
             <Button
                  size="small"
                  className={classes.nextButton1}
                  onClick={() => handlecanceluser()}
                >
                  Back
                </Button>
              <Button
                // style={{ margin: "5px" }}
                size="small"
                // color="info"
                className={classes.nextButton}
                disabled={callInProgress || !preview}
                onClick={(event) => esingDisable ? handleEsignNext() : handleProceedUpload()}
                >
                  Next
              </Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} text={generateLetter ?  sanctionletterLoaderMessage : "Processing..."} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
         {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      )}
       {confirmationModal1 && (
              <ConfirmationModal
                confirmationModal={confirmationModal1}
                confirmationModalHeader={confirmationModalHeader1}
                confirmationModalMsg={confirmationModalMsg1}
                handleNegativeButton={handleNegativeUploadResponse}
                handlePositiveButton={handlePositiveUploadResponse}
              />
            )}
       {showModal && (
              <OtpModal
                handleClose={handleClose}
                showModal={showModal}
                Otp={Otp}
                ResendOtp={sendEMailOtp}
              />
            )}
        </Grid>
  );
};

InsuranceLetter.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  closeModal: PropTypes.func,
};

export default InsuranceLetter;